import fetchJson from './fetch-json';
import Cookies from 'js-cookie';

const isServer = typeof window === 'undefined';

let API_BASE = '/iterable';

function performRequest(ctx, url, options = {}) {
  if (url[0] !== '/') {
    url = `/${url}`;
  }

  const opts = {
    ...options,
    headers: {
      ...options.headers,
    },
  };

  return fetchJson(`${API_BASE}${url}`, opts);
}

export class IterableSDK {
  constructor(ctx) {
    this.ctx = ctx;
  }

  post(url, body, options) {
    return performRequest(this.ctx, url, {
      ...options,
      headers: {
        ...options && options.headers,
      },
      body: JSON.stringify(body),
      method: 'POST',
    });
  }

  toJSON() { return undefined; }
}

export default function createIterableSdkInstance(ctx) {
  return new IterableSDK(ctx);
}



// WEBPACK FOOTER //
// ./spa/iterable-sdk.jsx